<script>
  import { Button,TabContent,Modal,ModalHeader,ModalBody,ModalFooter } from "sveltestrap";
  import TabPanelStack from "./TabPanelStack.svelte";

  import { afterUpdate } from "svelte";
  import { Input } from "sveltestrap";
  import { from } from "./from";

  export let settings;
  export let rec;
  import ReconConfig from "./ReconConfig.svelte";
  import ReconSummary from "./ReconSummary.svelte";

  import TabNav from "./TabNav.svelte";
  import TabPanel from "./TabPanel.svelte";
  import { parseUri } from "./utils";
  import { global, UI_ACTIONS_RESULT_GRID, UI_ML_EXPLAIN } from "./state.js";
import RecListWidget from "./RecListWidget.svelte";
import App from "./App.svelte";
import AppHeadNav from "./AppHeadNav.svelte";

  let colslider = 10;
  let emptyLeft;
  let leftCols;
  let rightCols;

  let outerjoin;
  let resultStyle = "summary";
  let result;
  let explain;

  let th = null;
  let contextMenu = null; // TODO - lift into own component
  let colIndex = -1;
  let rows = null;
  let table = null;

  let actionrow = null
  let open=false;

  // console.group("ReconWidget.<init>")
  // console.log("ReconWidget", rec.id, rec.name)

  const toggle = ()=>(open=!open)

  $:{
    [...document.querySelectorAll(".ojtable td")].forEach(x=>x.style.maxWidth=colslider+"rem")
  }
  const actions = global.env.flags[UI_ACTIONS_RESULT_GRID];
  const explainEnabled = global.env.flags[UI_ML_EXPLAIN];

  // https://stackoverflow.com/questions/16229494/converting-excel-date-serial-number-to-date-using-javascript#16233621
  function ExcelDateToJSDate(serial) {
    var utc_days  = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;                                        
    var date_info = new Date(utc_value * 1000);
    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;
    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  }

  function dateNumRenderer(col,value) {
    var out = value;
    if (value) {
      try {
        var date;
        if (col.type === "datenum-epoch-secs") {
          date = new Date(value*1000);
        } else if (col.type === "datenum-epoch-ms") {
          date = new Date(value);
        } else if (col.type === "datenum-excel") {
          date = ExcelDateToJSDate(value);
        }
        if (date) {
          if (col.format == "date-utc") {
            out = date.toISOString().substring(0,10);
          } else if (col.format == "datetime-utc") {
            out = date.toISOString()
            out = out.substring(0,10)+" "+out.substring(11,19)
          } 

          out = `<span title="${value}">${out}</span>`;
        }
      } catch(ex) {
        console.log("Error formatting date, col:", col.name, col.format, value, ex)
      }
    } 
    return out;
  }

  function headerCols(rows) {

      const aliasOrName = (c) =>
        c.alias && c.alias.length > 0 ? c.alias : c.name;

      const mapUiCols = (cols, side) =>
        cols
          .filter((c) => c.side === side && !c.hide)
          .map((c) => ({...c,
            aliased: aliasOrName(c),
            renderCell: c.type && c.type.indexOf("date") === 0 ? dateNumRenderer : (c,v)=>v,
          }));
      leftCols  = mapUiCols(rec.config.columns, "a");
      rightCols = mapUiCols(rec.config.columns, "b");
    // }

    const cols = leftCols.concat(rightCols);
    emptyLeft = leftCols.map((x) => "");

    return cols;
  }

  function renderOuterJoin(options, rows) {
    function ojHeader(rows) {
      var cols = [actionHeader(), ...headerCols(rows)];
      const html = cols
        .filter((col) => !!col)
        .map((col) => `<th data-colindex=${col.colIndex}>${col.aliased}</th>`)
        .join("");
      return html;
    }



    function ojRow(row,i) {
      return `<tr class="${row.rowtype}" 
        data-index="${i}"
        data-a-key="${row.left  ? row.left [rec.config.a_key]:''}" 
        data-b-key="${row.right ? row.right[rec.config.b_key]:''}" 
      >
      ${actionCell(row)}
      ${(row.left ? leftCols.map((c) => c.renderCell(c,row.left[c.name]) || "") : emptyLeft)
        .map(cell => `<td class=A><span class="cell">${cell}</span></td>`)
        .join("")} 
      ${(row.right ? rightCols.map((c) => c.renderCell(c,row.right[c.name]) || "") : [])
        .map(cell => `<td class=B><span class="cell">${cell}</span></td>`)
        .join("")}
      </tr>`;
    }

    function actionHeader() {
      return actions ? { aliased: "ACTION" } : undefined;
    }
    function actionCell(row) {
      const actions = global.env.flags["ui.actions-in-result-grid"];
      if (actions) {
        return `<td class=action>
        <button class="btn btn-sm btn-primary btn-xsm">Notify</button> 
        <button class="btn btn-sm btn-warning btn-xsm">Ack</button> 
        <button class="btn btn-sm btn-danger  btn-xsm">Alert</button></td>`;
      } else {
        return "";
      }
    }

    const html = `<table class=ojtable>
    <tr>${ojHeader(rows)}</tr>
    ${(rows || []).map((row,i) => ojRow(row,i)).join("\n")}
	</table>`;

    return html;
  }

  function runRec (e) {
    if (e) e.preventDefault();

    const data = {
      config: rec.config,
      uriA: rec.uriA || rec.a.uri,
      uriB: rec.uriB || rec.b.uri,
      email: rec.email
    };

    const opts = {
      method: "POST",
      body: JSON.stringify(data),
    };

    from(`/diff${global.noauth?"-noauth":""}?noauth=`+global.noauth, opts)
      .then((resp) => resp.json())
      .then((json) => {
        result = json;
        window.result = json;
      });

    return false;
  };

  function doExplain (e) {
    if (e) e.preventDefault();

    const data = {
      config: rec.config,
      uriA: rec.uriA || rec.a.uri,
      uriB: rec.uriB || rec.b.uri,
      email: rec.email
    };

    const opts = {
      method: "POST",
      body: JSON.stringify({
        config:rec.config,
        ...(result.file 
          ? {file:result.file} // logged in, fetch from s3 avoid size limits, faster
          : {rows:result.rows.filter(r=>['match','partial'].includes(r.rowtype))})
      }), // result uri... XXX
    };

    from(`/explain-results${global.noauth?"-noauth":""}?noauth=`+global.noauth, opts)
      .then((resp) => resp.json())
      .then((json) => {
        explain = json;
        window.explain = json;
        console.log(json)
        for (let colname of Object.keys(json)) {
          console.log(colname)
          console.log(json[colname].body)
        }
        rec.config.columns = 
          rec.config.columns
          .map(c=>{ if (c.side=='b')
                        c.explain = json[c.name]; return c })
        rec = rec
      });

    return false;
  };

  let activeTabId = rec.config && rec.config.mode === "colMap" ? "Definition" : "Result";
  let resultTabId = "Summary";

  $: {
    //console.log("Recon $ resultTabId", resultTabId)

    if (rec.config && rec.runImmed) {
      rec.runImmed = false; // for fast recs, could keep active to allow iteration - provide sub-sample for large recs?
      runRec();
    }
  }

  function doDownload(e) {
    e.preventDefault();
    console.log("download");
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/html;charset=utf-8, " + encodeURIComponent(renderOuterJoin(null, result.rows))
    );
    element.setAttribute("download", "result.html");
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  const getHighlightedCols = (rows) => {
    const clickCols = [];
    if (rows.length > 0) {
      const dataRow = rows.slice(1)[0];
      [...dataRow.cells].forEach((cell, i) => {
        if (cell.classList.contains("selected")) {
          clickCols.push(i);
        }
      });
    }
    return clickCols;
  };

  const unselectColIndex = (rows, colIndex) => {
    rows.forEach((row) => {
      if (row.cells[colIndex]) {
        row.cells[colIndex].classList.remove("selected");
      }
    });
  };

  const unselect = () => {
    // rows.forEach(row => {
    //   [...row.cells].forEach(cell => {
    //     cell.classList.remove("selected")
    //   })
    // })
    table
      .querySelectorAll(".selected")
      .forEach((elem) => elem.classList.remove("selected"));
  };

  const thColSelector = (e, mode) => {
    th = e.srcElement;
    colIndex = [...th.parentElement.cells]
      .map((x, i) => (x === th ? i : -1))
      .filter((x) => x >= 0)[0];
    table = th.parentElement.parentElement;
    rows = [...table.rows].slice(1);

    // XXX add a class to rows/table to prevent horz selection while vert is active
    // .horzSelectable ??
    if (mode === "over") {
      if (e.shiftKey) {
        rows.forEach((row) => {
          if (row.cells[colIndex]) {
            row.cells[colIndex].classList.add("selected");
          }
        });
      }
    } else if (mode === "out") {
      // if (!e.shiftKey) {
      //   unselectCols(rows, colIndex);
      // }
    } else if (mode === "click") {
      // const highlightedCols = getHighlightedCols(rows);
    } else if (mode === "context") {
      e.preventDefault();

      if (contextMenu == null) {
        const menu = document.createElement("div");
        menu.classList.add("thmenu");
        menu.innerHTML = `
          <div data-action=hide  >Hide columns</div>
          <div data-action=clear >Clear selection</div>
        `;
        contextMenu = menu;
        document.body.appendChild(menu);
        document.body.addEventListener(
          "click",
          () => (menu.style.display = "none")
        );
        menu.addEventListener("click", (e) => {
          const highlightedCols = getHighlightedCols(rows);
          // console.log("ctx click - hi",  highlightedCols)
          //unselectColIndex(rows, colIndex);
          unselect();
          if (e.target.dataset.action === "hide") {
            const colIndexes = highlightedCols.map(
              (hiIndex) => th.parentElement.cells[hiIndex].dataset.colindex
            );
            // console.log("ctx click - ci", colIndexes)
            colIndexes.forEach((ci) => {
              rec.config.columns
                .filter((c) => {
                  // console.log(c.colIndex, ci, c.colIndex == ci);
                  return c.colIndex == ci;
                })
                .forEach((c) => (c.hide = true));
            });
            // rec.config.columns.forEach(col => { col.hide = true });
            rec.config = rec.config; // redraw config panel
            result = result; // redraw trigger
          }
        });
      }
      //console.log("loc", e.clientY, e.pageY, e.scrollY)
      contextMenu.style.top = e.pageY + "px";
      contextMenu.style.left = e.pageX + "px";
      contextMenu.style.display = "block";

      return false;
    } else if (mode === "clear") {
      rows.forEach((row) => {
        [...row.cells].forEach((cell) => {
          cell.classList.remove("selected");
        });
      });
    }
  };

  function seek(name, e) {
    while (e.nodeName != name) {
      e = e.parentNode;
    }
    return e;
  }

  function rowClick(e) {
    var tr = seek("TR", e.target)
    actionrow = result.rows.filter(r => (r.left && r.left[rec.config.a_key] == tr.dataset.aKey) || (r.right && r.right[rec.config.b_key] == tr.dataset.bKey)).shift()
    if (actionrow) {
      open = true;
    }
  }

  afterUpdate(() => {
    [...document.querySelectorAll(".ojtable")].forEach((table) => {
      const first = table.rows[0];
      const ths = [...first.cells].slice(actions ? 1 : 0);
      ths.forEach((th) => {
        th.addEventListener("mouseover", (e) => thColSelector(e, "over"));
        th.addEventListener("mouseout", (e) => thColSelector(e, "out"));
        th.addEventListener("click", (e) => thColSelector(e, "click"));
        th.addEventListener("contextmenu", (e) => thColSelector(e, "context"));
      });

      if (global.env.flags["ui.actions-in-result-grid"]) {
        [...table.rows].forEach(row => {
          row.addEventListener("click", rowClick)
        })
      }
    });
  });

  let navItems = [ // todo, soft code subset names Linked/Unmatched vs Full/Partial
    {label:"Summary", summaryWidget: true},
    {label:"Consolidated",description:"Full results, including full matches", filter: () => true},
    {label:"Linked", description:"Matches", filter: (r) => r.rowtype === "match"},
    {label:"Unmatched", description:"Partial match, values differ.", filter: (r) => r.rowtype === "partial"},
    {label:"Unlinked "+rec.b.name, description:`${rec.a.name} only, Missing ${rec.b.name}`, filter: (r) => r.left && !r.right},
    {label:"Unlinked "+rec.a.name, description:`${rec.a.name} only, Missing ${rec.b.name}`, filter: (r) => !r.left && r.right},
    explainEnabled ? {label:"Explain", onclick:doExplain} : undefined,
    {label:"Download", onclick:doDownload},
  ].filter(x=>x)

  // console.groupEnd();
</script>

<style>
.results .card {
  overflow-x: scroll;
}

.rule-col {
  width: 10rem;
  display: inline-block;
}

.pre-oj label {
  display: inline-block;
}

.pre-oj span.pre-span {
  display: inline-block;
  width: 25rem;
}
</style>

<div class="row pt-2">
  <div class="col-sm">
    <TabNav
      items={["Definition", "Result"].map((x) => ({ label: x, id: x }))}
      bind:activeTabId
      tabs={false}
      name={rec.id+"/page"}
    >
      <div class="row pt-2">
        <div class="col-sm">
          <TabPanel tabId="Definition">
            <div class="row">
              <ReconConfig bind:rec bind:settings />
            </div>
          </TabPanel>
          <TabPanel tabId="Result">
            <form method="POST" action="/diff">
              <div class="row">
                <div class="form-group col-sm">
                  <div
                    id="submit"
                    on:click={runRec}
                    class="btn btn-secondary ml-auto mb-1 mt-1"
                  >Run</div>
                </div>
              </div>
            </form>
            {#if result}
              <div class="row">
                <div class="col-sm">
                  <div class="card p-2 results">
                    <TabNav
                      items={navItems.map((x) => ({ label: x.label, id: x.label, onclick: x.onclick }))}
                      bind:activeTabId={resultTabId}
                      tabs={false}
                      name={rec.id+"/result"}
                    >
                    {#each navItems as tab}
                      {#if tab.summaryWidget}
                      <TabPanel tabId="{tab.label}">
                        <ReconSummary rec={rec} result={result} />
                      </TabPanel>
                      {:else if !tab.onclick}
                      <TabPanel tabId="{tab.label}">
                        <div class="row">
                          <div class="col-sm">
                            <div class="card p-2">
                              <div class="pre-oj">
                                <span class="pre-span">{tab.description}</span>
                                <span style="float: right;">Col widths:
                                  <Input style="display: inline-block; width: 25rem; vertical-align: text-bottom;"
                                    class="pre-input" type="range" name="range" 
                                    min={3} max={100} step={1} bind:value={colslider}
                                  />
                                </span>
                              </div>
                              {@html renderOuterJoin(null, result.rows.filter(tab.filter))}
                            </div>
                          </div>
                        </div>
                      </TabPanel>
                      {/if}
                    {/each}
                    </TabNav>
                  </div>
                </div>
              </div>
            {/if}
          </TabPanel><!-- Run -->
        </div>
      </div>
    </TabNav><!-- Definition / Run tabs-->
  </div>
</div>

<Modal isOpen={open} {toggle} modalClassName="modal-lg">
  <ModalHeader {toggle}>All Fields</ModalHeader>
  <ModalBody>
    {#each [{label:rec.a.name,obj:actionrow.left},{label:rec.b.name,obj:actionrow.right}] as side}
      <div  class="mb-2">
        <h2>{side.label}</h2>
        <table>
        {#each Object.entries(side.obj || {"Missing row":""}) as kv }
          <tr>
            <td>{kv[0]}</td>
            <td>{kv[1]}</td>
            {#if rec.config.columns.filter(c=>c.name == kv[0] && c.compareWithCol).shift() }
              <td>{actionrow.right[rec.config.columns.filter(c=>c.name == kv[0] && c.compareWithCol).shift().name]}</td>
              <td>{rec.config.columns.filter(c=>c.name == kv[0] && c.compareWithCol).shift().name}</td>
            {/if}
          </tr>
        {/each}
        </table>
      </div>
    {/each}
  </ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={toggle}>Do Something</Button>
    <Button color="secondary" on:click={toggle}>Cancel</Button>
  </ModalFooter>
</Modal>
